//
import BranchOfficeModel from "@/models/General/GBranchOffice"
import UserModel from "@/models/General/GUser"

//
import { required } from "@/services/validations"

//
export default [
    {
        name: 'names',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Nombre',
            rules: [required],
        },
    },
    {
        name: 'last_name1',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Primer Apellido',
            rules: [required],
        },
    },
    {
        name: 'last_name2',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Segundo Apellido',
        },
    },
    {
        name: "pos_workstation_type_id",
        type: "autocomplete",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            items: [
                {
                    text: "Sala",
                    value: 1,
                },
                {
                    text: "Terreno",
                    value: 2,
                },
                {
                    text: "Call Center",
                    value: 3,
                },
                {
                    text: "Impresion Automatica",
                    value: 5,
                },
            ],
            label: "Tipo",
            rules: [ required ],
        },
    },
    {
        name: "g_branch_office_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: "name",
            itemValue: "id",
            label: "Sucursal",
            model: BranchOfficeModel,
            noObject: true,
            paramSearch: "address",
            rules: [ required ],
        },
    },
    {
        name: "g_seller_user_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: "full_name",
            itemValue: "id",
            label: "Vendedor",
            model: UserModel,
            paramFilter: {
                is_ground_seller: true,
            },
            noObject: true,
            rules: [ required ],
        },
    },
    {
        name: "token_type",
        type: "text-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Tipo de token",
            readonly: true,
            rules: [ required ],
        },
    },
    {
        name: "g_workstation_user_url_token",
        type: "text-field",
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: "Token",
            readonly: true,
            rules: [ required ],
        },
    },
]